import './common/owl-carousel';
import './common/base';
import './common/forms';
import './common/lazy';
import './common/menu';
import './common/tables';
import './common/tooltip';
